
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Main } from "../theme";
import { Box, Toolbar } from "@mui/material";
import { BuscadorGlobal, NavBarScreen, SlideShowMenu } from "../components/ui";



//Rutas de Dashboard
import { MisOpciones, MisPedidos, CambioClave, DetallesDeMiOP, MiPerfilUsuario, MiCarnet } from "../components/dashboard/pages";
// Rutas de Ops
import { DetallesItemProduccion, DetallesOpCard, MisItemsDeTrabajo, TodasOps, AbonosDeOpNueva, InformacionDeUsuarios, TodosLosItems, EditarOAgregarOP, ItemsListosParaTrabajar, RegistroColaborador, InventarioOp } from "../components/op/pages";
// Rutas de Usuarios
import { ActualizarCliente, ListadoTodosClientes, CrearUsuarios, ActualizarUsuario, ListadoUsuarios, ListadoDeSocios, MisClientes, CrearClientes, VerOpsPorCliente, DeudaClienteOp, ListadoDeColaboradores, OpcionesUsuario, SettingsUsuario } from "../components/superAdmin/pages";
// Rutas de Cotizacion 
import { ListadoTodasCotizaciones, ListadoVentaGuardada } from "../components/cotizacion/pages";
// Rutas de Productos
import { ListadoProductos, CrearProducto, ActualizarProducto, ExibirProductosScreen, DetalleProducto } from "../components/productos/pages";
// Rutas de Compra y Checkout
import { CheckoutScreen, ComprarAhora, CotizacionScreen, DetalleItemCompra } from "../components/compras/pages";
// Rutas de Categoria
import { CrearCategoria, ListadoCategorias, ActualizarCategoria, CategoriasScreen } from "../components/categorias/pages";










// Rutas de Caja
import { CajaScreen, ComparativaScreen, GastosScreen, InventarioScreen, ListadoUnidadMedida, ReportesInventario, PagosScreen, FormularioCrearPagos, DetallePagoInventario, DetallesGasto, AbonosGastos, NotasIngresoStock, LotesXStock } from "../components/caja/pages";
// Rutas de Proveedores
import { CrearProveedores, ListadoProveedores } from "../components/proveedores/pages/";
// Rutas de los Settings
import { ConfiguracionSlideShow } from "../components/settings/pages";

// Rutas de Productos
// import { DetalleProducto } from "../components/productos/DetalleProducto"
import { InfoUsuario } from "../components/op/InfoUsuario"

// Rutas de Comprar Y Carrito
import { SubirImagenPago } from "../components/dashboard/SubirImagenPago"


// Abonos
import { InfoCliente } from "../components/op/InfoCliente"






export const SuperAdminRouter = () => {

  const { isSidebarOpen } = useSelector( state => state.iva ); 


    return (

        <>
        <Box sx={{ display:'flex' }}>
            <NavBarScreen />
            <SlideShowMenu />

            <Main open={isSidebarOpen}>
            <Toolbar />

              <Box>
              <Routes>

                  {/* Dashboard */}
                  <Route path="/" element={ <MisOpciones /> } />
                  <Route path="/cambio-clave" element={ <CambioClave /> } />
                  <Route path="/perfil" element={ <MiPerfilUsuario /> } />   
                  {/* Buscador Global */}
                  <Route path="/buscador/global" element={<BuscadorGlobal />} />
                  {/* Servicio Usuarios  */}
                  <Route path="/crearUsuario" element={ <CrearUsuarios />} />
                  <Route path="/actualizar-user/:id" element={<ActualizarUsuario />} />
                  <Route path='/listado-super' element={<ListadoUsuarios />} />
                  <Route path='/listadosocios' element={<ListadoDeSocios />} />
                  <Route path='/listadocolaborador' element={<ListadoDeColaboradores />} />
                  <Route path="/opciones-user/:id" element={<OpcionesUsuario />} />
                  <Route path="/settings/:id" element={<SettingsUsuario />} />
                  <Route path="/ops-user/:id" element={<VerOpsPorCliente />} />
                  {/* servicios de Clientes */}
                  <Route path="/listadoClientes" element={<ListadoTodosClientes />} />
                  <Route path="/crearcliente" element={<CrearClientes />} />
                  <Route path="/clientesxdistri" element={<MisClientes />} />
                  {/* Servicio de O.P. e Items */}
                  <Route path="/op-todas" element={ <TodasOps /> } />
                  <Route path="/detalles-op/:id" element={<DetallesOpCard />} />
                  <Route path="/abonosxop/:id" element={ <AbonosDeOpNueva /> } />
                  <Route path="/op-disponibles" element={ <ItemsListosParaTrabajar /> } />
                  <Route path="/mis-op" element={<MisItemsDeTrabajo />} />
                  <Route path="/registro/:id/items" element={<RegistroColaborador />} />
                  <Route path="/todos-items" element={ <TodosLosItems /> } />
                  <Route path="/editar/:id" element={<EditarOAgregarOP />} />
                  <Route path="/inventario/:id" element={<InventarioOp />} />
                  <Route path="/dt-pro-op/:id" element={<DetallesItemProduccion />} />
                  {/* Servicios de Carrito y Compras */}
                  <Route path="/detproventa/:cat/:prod" element={ <DetalleProducto />} />
                  <Route path="/checkout" element={ <CheckoutScreen />} />
                  <Route path="/comprar-ahora" element={ <ComprarAhora /> } />
                  <Route path="/filtro/:id"  element={ <ExibirProductosScreen />} />

                  {/* Cotizacion */}       
                  <Route path="/cotizacion" element={ <CotizacionScreen />} />
                  <Route path="/cotizacion/all" element={<ListadoTodasCotizaciones />} />
                  <Route path="/ventas/guradada" element={<ListadoVentaGuardada />} />
                   {/* Servicio de Productos y Categorias */}
                  <Route path="/listaProducto" element={ <ListadoProductos />} />
                  <Route path="/crearProducto" element={ <CrearProducto />} />
                  <Route path="/actualizar-prod/:id" element={<ActualizarProducto />} />
                  <Route path="/crear-categoria" element={<CrearCategoria/>} />
                  <Route path="/lista-categoria" element={<ListadoCategorias />} />
                  <Route path="/actualizar-categ/:id" element={<ActualizarCategoria />} />
                  <Route path="/ver-productos" element={ <CategoriasScreen />} />
                  {/* Caja o PyG*/}
                  <Route path="/caja" element={<CajaScreen />} />
                  <Route path="/uni-medi" element={<ListadoUnidadMedida />} />
                  <Route path="/gastos" element={<GastosScreen />} />
                  <Route path="/gasto/ver/:id" element={<DetallesGasto />} /> 
                  <Route path="/gasto/abonos/:id/" element={<AbonosGastos />} />   
                  <Route path="/comparativa" element={<ComparativaScreen />} />
                  {/* Rutas de proveedores */}
                  <Route path="/crear-proveedor/:id" element={ <CrearProveedores /> } />
                  <Route path="/list-proveedor" element={ <ListadoProveedores />} />
                  {/* Inventario o Stock */}
                  <Route path="/inventario/list" element={ <InventarioScreen /> } /> 
                  <Route path="/reportes/:id" element={<ReportesInventario />} />
                  <Route path="/lotes/:id" element={<LotesXStock />} />
                  <Route path="/notas/ingreso" element={<NotasIngresoStock />} />




                  {/* Rutas de Configuracion de la Pagina */}
                  <Route path="/slideshow" element={<ConfiguracionSlideShow />} />










                  <Route path="/actualizarCliente/:id" element={<ActualizarCliente />} />
                  <Route path="/mis-pedidos" element={ <MisPedidos /> } />
                  <Route path="/trayectoria/:id" element={ <DetallesDeMiOP /> } />
                  <Route path="/micarnet" element={ <MiCarnet /> } />   
                  <Route path="/foto-pago/:id" element={ <SubirImagenPago /> } />
                  {/* Servicio de O.P. */}
                  <Route path="/detalles/:id" element={<InformacionDeUsuarios />} />
                  {/* Abonos */}
                  <Route path="/deuda-cliente/:id" element={<DeudaClienteOp />} />
                  <Route path="/detalle-item/:id" element={ <DetalleItemCompra />} />
                  <Route path="/info-user/:id" element={<InfoUsuario />} />
                  <Route path="/info-clien/:id" element={<InfoCliente />} />
                  <Route path="/pagos" element={<PagosScreen />} />     
                  <Route path="/pagos/create" element={<FormularioCrearPagos />} />
                  <Route path="/pagos/detalle/:id/pago" element={<DetallePagoInventario />} />
                  {/* <Route path="/stock/:id/update" element={<DetallesDeInventario />} /> */}
                </Routes>
              </Box>


            </Main>
        </Box>
        </>
    )
}
